import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error(error, instance, info)

    Sentry.captureException(error)
  }
})
